export default __webpack_public_path__ + "static/media/yoga.9faaed0b.jpg";